import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/homeworks', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/homeworks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/homeworks/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeStatus = (id, data) => {
  return httpClient
    .put(`/api/homeworks/change-status/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getSubject = (class_id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/queries/${class_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getClass = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTeacher = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const removeFile = (Options = {}) => {
  return httpClient
    .get('/api/homework-remove-files', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const sendNotification = id => {
  return httpClient
    .get(`/api/homework-send/notifications/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  removeFile,
  getTeacher,
  getClass,
  getSubject,
  get,
  find,
  store,
  update,
  changeStatus,
  sendNotification
}
